/**
 * Created by OBL on 14/01/2016.
 */
define('adminLmbSmpMatsController',[
    'module',
    'underscore',
    'app',
    'adminLmbSmpMatsView',
    'bootbox',
    'lmbSmpMatCreateEditLayoutView',
    'settings',
    'entities/lmbsmpmats'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var AdminLmbSmpMatListController = {
        showLmbSmpMatList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'lmbsmpmat:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showLmbSmpMatAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                lmbSmpMatModel: App.request('lmbsmpmat:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('lmbsmpmat.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('lmbsmpmat:get-collection-url'),
                rowCountUrl: App.request('lmbsmpmat:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('lmbsmpmat.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('lmbsmpmat:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = AdminLmbSmpMatListController;
});
